export default "__VITE_ASSET__DNalT8In__"